import { useEffect } from "react";

/** Sets the browser tab title while the page is mounted; restores on unmount. */
export function usePageTitle(title) {
    useEffect(() => {
        if (!title) return undefined;
        const prevTitle = document.title;
        document.title = title;
        return () => {
            document.title = prevTitle;
        };
    }, [title]);
}
